import { useNotifications } from '@/data/Content/Notifications';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { UserLogon } from '@/data/Content/Login';
import { ErrorType } from '@/data/types/Error';
import { useEffect } from 'react';

const PASSWORD_EXPIRED_MODAL_TITLE = 'Contraseña expirada';
const PASSWORD_EXPIRED_MODAL_MESSAGE =
	'Por seguridad, es necesario actualizar tu contraseña, ya que ha expirado. Crea una nueva contraseña para continuar y acceder nuevamente a tu cuenta.';

export type PasswordExpiredState = (ErrorType & { user: UserLogon }) | null;

export const usePasswordExpiredRedirect = (
	passwordExpired: PasswordExpiredState,
	setPasswordExpired: (value: PasswordExpiredState) => void,
	onBeforeRedirect?: () => void
) => {
	const { notifyError } = useNotifications();
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');

	useEffect(() => {
		if (passwordExpired === null) {
			return;
		}
		const expiredLogonId = passwordExpired.user?.logonId || passwordExpired.user?.email || '';
		setPasswordExpired(null);
		onBeforeRedirect?.();
		notifyError(PASSWORD_EXPIRED_MODAL_MESSAGE, PASSWORD_EXPIRED_MODAL_TITLE);
		router.push({
			pathname: RouteLocal.ForgotPassword.route.t(),
			...(expiredLogonId ? { query: { email: expiredLogonId } } : {}),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [passwordExpired]);
};
